import React from "react";

import { Link as RouterLink } from "react-router-dom";

import {
  Box,
  Grid,
  Typography,
  Divider,
  Card,
  CardActionArea,
  CardContent,
} from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";

import routes, { MY_ENTRY, STANDINGS } from "../../data/routes";

import StandingsPreview from "./StandingsPreview";

const styles = (theme) => ({
  navCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    height: "100%",
  },
  navCardContent: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  navIcon: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.primary.main,
    "& svg": {
      fontSize: "2rem",
    },
  },
});

function CompletedSeason({ classes, season, baseUrl, user }) {
  const { name, isBachelorette, isScoringComplete } = season;
  const showName = isBachelorette ? "Bachelorette" : "Bachelor";

  return (
    <Box>
      <Box mb={3}>
        <Typography variant="h4" gutterBottom>
          {name}'s {showName} Season Is Over!
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Thanks for playing along this season.
        </Typography>
      </Box>

      <Divider />

      <Box mt={3}>
        {isScoringComplete ? (
          <>
            <Box mb={3}>
              <Typography variant="h5" gutterBottom>
                Final scores are in!
              </Typography>
              <Typography variant="body1" paragraph>
                The season has wrapped up and all scores have been tallied. See
                how your predictions stacked up against everyone else's.
              </Typography>
              <StandingsPreview season={season} baseUrl={baseUrl} />
            </Box>
            <Grid container spacing={2}>
              {user && (
                <Grid item xs={12} sm={6}>
                  <Card className={classes.navCard} elevation={0}>
                    <CardActionArea
                      component={RouterLink}
                      to={`${baseUrl}${routes[MY_ENTRY].path}`}
                    >
                      <CardContent>
                        <Box className={classes.navCardContent}>
                          <Box className={classes.navIcon}>
                            {routes[MY_ENTRY].icon}
                          </Box>
                          <Box>
                            <Typography variant="h6">
                              {routes[MY_ENTRY].name}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                              Review your picks and final score
                            </Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              )}
              <Grid item xs={12} sm={user ? 6 : 12}>
                <Card className={classes.navCard} elevation={0}>
                  <CardActionArea
                    component={RouterLink}
                    to={`${baseUrl}${routes[STANDINGS].path}`}
                  >
                    <CardContent>
                      <Box className={classes.navCardContent}>
                        <Box className={classes.navIcon}>
                          {routes[STANDINGS].icon}
                        </Box>
                        <Box>
                          <Typography variant="h6">
                            {routes[STANDINGS].name}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            See how everyone ranked this season
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </Grid>
          </>
        ) : (
          <Box mt={2}>
            <Typography variant="h5" gutterBottom>
              Scoring in progress
            </Typography>
            <Typography variant="body1">
              The season has wrapped up — check back soon for final scores!
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default withStyles(styles)(CompletedSeason);